
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plans/[bootcampType]",
      function () {
        return require("private-next-pages/plans/[bootcampType]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plans/[bootcampType]"])
      });
    }
  